import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { AuthGaurdService } from './auth-gaurd.service';
import { Observable } from 'rxjs';
import { CommPlan } from '../models/commission/comm-plan.model';
import { environment } from '../../environments/environment';
import { RateCodes } from '../models/commission/rate-codes.model';
import { CommPlanDetail } from '../models/commission/comm-plan-detail.model';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';
import { AddUser } from '../models/manageUsers/add-user.model';
import { KomFeed } from '../models/commission/kom-feed.model';
import { CallDetails } from '../models/commission/call-details.model';

@Injectable({
    providedIn: 'root'
})
export class ManageCodesService {

    host: string = environment.apiUrl + 'managecodes';
    tokenId: string = '';
    commModel = new CommPlan();
    kpiDetails: CommPlanDetail[] = [];
    salesChannels: string[] = [];
    commData: CommPlan[] = [];
    komFeedModel = new KomFeed();
    editKomFeedModel = new KomFeed();
    loggedinUser: string = '';
    languages: string[];
    payrollCalender: string[];
    salesRepData: KomFeed[];
    callDetailModel = new CallDetails();

    constructor(private http: HttpClient, private logger: LoggerService, private authgurdService: AuthGaurdService, private authGaurdService: AuthGaurdService) {
        this.tokenId = this.authgurdService.getToken();

        this.loggedinUser = this.authGaurdService.loginUser();
        if (this.loggedinUser == "" || this.loggedinUser == null) {
            this.loggedinUser = "NA"
        } else {
            this.loggedinUser = this.authGaurdService.loginUser();
        }
    }

    public getCodeTypes(): Observable<RateCodes[]> {
        return this.http.get<RateCodes[]>(`${this.host}/getproducts`);
    }
    public getEmpSupervisors(val: string): Observable<AddUser[]> {
        return this.http.get<AddUser[]>(`${this.host}/getempsupervisors` + '/' + val);
    }
    public getSupervisors(): Observable<AddUser[]> {
        return this.http.get<AddUser[]>(`${this.host}/getsupervisors`);
    }
    public getCorps(): Observable<RateCodes[]> {
        return this.http.get<RateCodes[]>(`${this.host}/getcorps`);
    }
    public getAssignedCorps(id:string,edate:Date): Observable<RateCodes[]> {
        return this.http.get<RateCodes[]>(`${this.host}/getassignedcorps` + '/' + id + '/' + edate);
    }
    public getProducts(salesChannel: string): Observable<RateCodes[]> {
        return this.http.get<RateCodes[]>(`${this.host}/getproductsbysc` + '/' + salesChannel);
    }
    public getAllCodes(productid: number, corpid: number): Observable<any> {
        return this.http.get<any>(`${this.host}/ratecodeslist` + '/' + productid + '/' + corpid);
    }
    public getcommPlans(productid: number): Observable<any> {
        return this.http.get<any>(`${this.host}/commPlanlist` + '/' + productid);
    }
    public addRateCode(rateCodeModel: RateCodes): Observable<CustomHttpRespone> {
        return this.http.post<CustomHttpRespone>(`${this.host}/addRateCode`, rateCodeModel);
    }
    public updateRateCode(rateCodeModel: RateCodes): Observable<CustomHttpRespone> {
        return this.http.post<CustomHttpRespone>(`${this.host}/updateRateCodes`, rateCodeModel);
    }


}